export default __webpack_public_path__ + "static/media/home.4103d811.svg";